<div class="container notifications" *ngIf="isAnonymousUser && currentNotifications.length > 0">
  <div class="thread-wrapper" *ngFor="let currentNotification of currentNotifications">
    <div>
      <div class="notification ckeditor-text" [innerHTML]="currentNotification.message"></div>

      <div class="follow-ups">
        <div class="follow-up-wrapper" *ngFor="let followUp of currentNotification.followUps">
          <div class="timestamp"><i class="far fa-clock me-1"></i>{{ followUp.addedDate | date: dateFormat }}:</div>
          <div class="notification ckeditor-text" [innerHTML]="followUp.message"></div>
        </div>
      </div>
    </div>
  </div>
</div>
